import React, { useContext ,useState ,useEffect} from "react";
import { AppContext } from "../AppContext";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "./video.css";
import Modal from "../components/Modal";
export default function Video() {
  const { data } = useContext(AppContext);
  const [state, setstate] = useState(0);
  const [open, setOpen] = useState(false);
  const videoRef  = React.createRef();
  useEffect(() => {
      if (open) {
        // 这里的代码会在 open 变为 true 且组件更新后执行
        console.log("弹窗已打开，DOM 已更新");
  
      }
    }, [open]);
    const handleOpen = (val,index) => {
    setstate(index)
    
    setOpen(true);
  };
  return (
    <div id="video">
      <img src={`/image/11.png`} className="pageTitle" />
      <div  className="pContent" >
        {
          data?.video.map((val,index)=>
            <div className="video-con" key={index} onClick={()=>handleOpen(val,index)} >
              <img src={val.src1} />
              <span>{val.name}</span> 
            </div>
          
          )
        }
      </div>
      <Modal open={open} onClose={() => setOpen(false)}>
          <h2 >{data?.video[state].name}</h2>
          <video ref={videoRef}   
            webkit-playsinline='true' 
            playsInline={true}
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline ='true'
            x-webkit-airplay='allow' autoPlay
            controls loop preload='true' src={data?.video[state].src} ></video>
      </Modal>
    </div>
  );
}